import React, { Component } from "react"

export default class SweetStain extends Component {
  render() {
  return (
      <div className="portfoliosmalldetwrap">
        <div className="portdescwrap">
          <div className="portdesc">
            <p className="portdesctitle">Sweet Stain</p>
            <p className="portdesctext">Web development & writing for Sweet Stain, a platform that rendders Fashion through the lens of Online Luxury Clothing culture.</p>
          </div>
        </div>
        <div className="portlinkwrap">
          <a href="https://www.sweet-stain.com/" target="_blank" rel="noopener noreferrer"><p className="linktext">Website</p></a>
        </div>
      </div>
  )
}
}

